import { IFlowItem } from '/@/views/automation/types';
import { TimeOfIntervalPickerType } from '/@/components/ChatBot/Common/TimeOfIntervalPicker/types';

export enum WidgetStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
}

interface IWidgetIconConfig {
  color: string;
  size: number;
  largeSize: number;
}

export const widgetsIconConfig: IWidgetIconConfig = {
  color: '#1890ff',
  size: 24,
  largeSize: 32,
};

export enum WidgetsType {
  COMMENT = 'feed_comment_trigger',
  REF = 'messenger_ref_url',
}

export type WidgetsListItem = {
  icon: string;
  text: string;
  value: string;
  loading?: boolean;
};

interface IWidgetsList {
  [propName: string]: WidgetsListItem;
}

type facebookPostItem = {
  id: string;
  is_eligible_for_promotion: boolean;
  status_type: string;
  picture: string;
  full_picture: string;
  permalink_url: string;
  created_time: string;
  is_hidden: boolean;
  is_published: boolean;
  promotable_id: string;
};

type WidgetsDataRef = {
  set_up: {
    ref: string;
    ref_payload_field_id: number;
  };
};

type messagesMapping = {
  id: number;
  content: string;
};

export type WidgetsDataComment = {
  feed_comment_settings: {
    posts: string[];
    eula: boolean;
    exclude_keywords: string;
    include_keywords: string;
    track_root_comment_only: boolean;
    track_all_posts?: boolean;
    only_unsubscribed?: boolean;
    only_first_comment?: boolean;
  };
  feed_comment_welcome: {
    public_reply_messages: string[];
    public_reply_messages_mapping?: messagesMapping[];
    like_user_comment: boolean;
    random_delay: boolean;
    delay_time: TimeOfIntervalPickerType;
  };
};

export interface IWidget {
  _id: string;
  name: string;
  page_id?: number;
  widget_type: WidgetsType;
  messenger_ref_url?: string;
  status: WidgetStatus;
  setting_data: WidgetsDataRef | WidgetsDataComment;
  flow: IFlowItem;
}

export const widgetsList: IWidgetsList = {
  [WidgetsType.COMMENT]: {
    icon: 'ant-design:comment-outlined',
    text: '评论',
    value: WidgetsType.COMMENT,
  },
  [WidgetsType.REF]: {
    icon: 'codicon:link',
    text: 'Ref',
    value: WidgetsType.REF,
  },
};
